import TimeConstants from 'owa-datetime-utils/lib/TimeConstants';
import { owaDate, OwaDate, getYear, getMonth, getDate, getHours, getMinutes } from 'owa-datetime';

/**
 * Adds a given amount of minutes to the face-value of a date.
 * This does NOT take into consideration daylight-savings and time-zone changes
 * and it is therefore suitable for UI calculations that are based on the user's
 * perception of "time" and not the UTC version of it.
 * We use it when converting points to dates during clicks in the calendar surface.
 * @example
 * In PST, Nov 5 2017 was DST-change:
 * const a = userDate(2017, 10, 5, 1) // 2017-11-05T08:00:00.000Z, 'Sun Nov 05 2017 01:00:00 GMT-0700 (Pacific Daylight Time)'
 * const b = addMinutes(a, 60)        // 2017-11-05T09:00:00.000Z, 'Sun Nov 05 2017 01:00:00 GMT-0800 (Pacific Standard Time)'
 * const c = addDisplayMinutes(a, 60) // 2017-11-05T10:00:00.000Z, 'Sun Nov 05 2017 02:00:00 GMT-0800 (Pacific Standard Time)'
 */
export function addDisplayMinutes(date: OwaDate, minutes: number): OwaDate {
    const minutesPerHour = TimeConstants.MinutesInOneHour;
    const startMinutes = getHours(date) * minutesPerHour + getMinutes(date);
    const totalMinutes = startMinutes + minutes;
    const newHour = Math.floor(totalMinutes / minutesPerHour);
    const newMinutes = Math.floor(totalMinutes % minutesPerHour);
    return owaDate(date.tz, getYear(date), getMonth(date), getDate(date), newHour, newMinutes);
}
